import { StateInterface } from "./state";
import { OrganisationModel } from "modules/relationprofile/models";
import { PrivatePersonModel } from "../models/privatePerson";

export default {
  setCurrentOrganisation(
    state: StateInterface,
    organisation: OrganisationModel
  ): void {
    state.organisation = organisation;
  },
  setCurrentPrivatePerson(
    state: StateInterface,
    person: PrivatePersonModel
  ): void {
    state.privatePerson = person;
  }
};
